import * as i18next from 'i18next'
import 'intersection-observer'
import * as React from "react"
import { AsyncState, IOWidget, Updater, async, fromJSX } from "widgets-for-react"
import { PublicSiteState } from "../../../../../../../root/state"
import { CMSState } from "../../../../cms/blocks/types.gen"
import { ParsedTaxonomyTermPressContact } from "../../../../drupal/types_and_parser/types.ext.gen"
import { InnerHtmlWrapper } from "../../../../utils/InnerHtmlWrapper"
import { PressContactConfig } from "../../../utils/pressContactConfig"

export type PressContactBlockProps = {
    blockIndex: number,
    contactPerson: AsyncState<PressContactConfig>,
    pressContact: ParsedTaxonomyTermPressContact
}

export type PressContactBlockStyle = Partial<{
    block_classname: string
}>


const setPressContactState = (contactFunction: Updater<AsyncState<PressContactConfig>>, blockIndex: number, state: CMSState): CMSState => {
    let current_block = state.blocks.get(blockIndex);
    if (current_block.kind == "pressContactBlock") {
        const newState = contactFunction(current_block.value[0].contactPerson);
        if (newState.kind == 'loaded') {
            let res = {
                ...state,
                blocks: state.blocks.set(blockIndex,
                    {
                        ...current_block,
                        value: [
                          {
                           ...current_block.value[0],
                            contactPerson: newState
                          },
                          current_block.value[1]
                        ]
                    }
                )
            }
            return res
        }
    }
    return state;
}

export function pressContactBlock(
    props: PressContactBlockProps,
    options?: { style: PressContactBlockStyle; key?: string }
): (s: CMSState) => IOWidget<PublicSiteState, Updater<CMSState>> {
    return (s: CMSState) => (public_state: PublicSiteState) =>
        fromJSX((setState) => {
                if (props.contactPerson.kind != 'loaded') return async(props.contactPerson).run(a => {
                    setState(s1 => setPressContactState(a, props.blockIndex, s1))
                })

                return (
                    <section className={`block block--press grid--spacing ls-block-spacing`}>
                        {props.pressContact ?
                            <div className="block__inner ls-container">
                                <header className="block__header">
                                    <h2 className="block__title title--l">{i18next.t("Common:PressContact.Title")}</h2>
                                </header>
                                <div className='block__content'>
                                    <p className='block__name'>{props.pressContact.label}</p>
                                    <div className='block__column'>
                                        <ul className='block__list'>
                                            <li className='block__item block__item--bottom'>{props.pressContact.field_designation}</li>

                                            {props.pressContact.field_phone_number.toArray().map(phone => <li className='block__item block__item--icon'>
                                                <svg className="block__icon" height="22" width="22">
                                                    <use xlinkHref="#icon--phone" />
                                                </svg>
                                                <a href={`tel: ${phone}`}>{phone}</a>
                                            </li>)}

                                            {props.pressContact.field_email.toArray().map(email => <li className='block__item block__item--icon'>
                                                <svg className="block__icon" height="18" width="22">
                                                    <use xlinkHref="#icon--mail" />
                                                </svg>
                                                <a href={`mailto: ${email}`}>{email}</a>
                                            </li>)}
                                        </ul>
                                    </div>
                                    <div className='block__column'>
                                        <InnerHtmlWrapper className="block__text" text={props.pressContact.description} />
                                    </div>
                                </div>
                            </div>
                            :
                            <div className="block__inner ls-container">
                                <header className="block__header">
                                    <h2 className="block__title title--l">{i18next.t("Common:PressContact.Title")}</h2>
                                </header>
                                <div className='block__content'>
                                    <p className='block__name'>{props.contactPerson.value.field_name.reduce((xs, x) => xs + x.value, '')}</p>
                                    <div className='block__column'>
                                        <ul className='block__list'>
                                            <li className='block__item block__item--bottom'>{props.contactPerson.value.field_designation.reduce((xs, x) => xs + x.value, '')}</li>

                                            {props.contactPerson.value.field_phone_number.map(phone => <li className='block__item block__item--icon'>
                                                <svg className="block__icon" height="22" width="22">
                                                    <use xlinkHref="#icon--phone" />
                                                </svg>
                                                <a href={`tel: ${phone.value}`}>{phone.value}</a>
                                            </li>)}

                                            {props.contactPerson.value.field_e_mail.map(email => <li className='block__item block__item--icon'>
                                                <svg className="block__icon" height="18" width="22">
                                                    <use xlinkHref="#icon--mail" />
                                                </svg>
                                                <a href={`mailto: ${email.value}`}>{email.value}</a>
                                            </li>)}


                                        </ul>
                                    </div>
                                    <div className='block__column'>
                                        <InnerHtmlWrapper className="block__text" text={props.contactPerson.value.field_introduction.map(x => x.value).join()} />
                                    </div>
                                </div>
                            </div>
                        }

                    </section>
                )
            },
        )
}
